@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.directActionButton {
  padding: 10px 0 10px 10px;
  border-radius: 6px;
  height: 40px;
  --color: var(--light-7);

  [data-autopilot-system-redesign='on'] & {
    padding: 8px 0 8px 2px;
    border-radius: 8px;
    height: 32px;
  }

  &.hovered {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background: var(--dark-20);
    border-radius: 100px 0 0 100px;

    [data-autopilot-system-redesign='on'] & {
      border-radius: 8px 0 0 8px;
    }

    .activeIndicator {
      background: var(--hover-color, var(--neutral-10));
    }
  }

  &.quoteButton {
    padding-left: 8px;

    [data-autopilot-system-redesign='on'] & {
      padding-left: 8px;
    }
  }
}

.directActionButton {
  &.hovered {
    background: var(--dark-4);
  }
}

.doubleActionButton {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  overflow: hidden;

  [data-autopilot-system-redesign='on'] & {
    border-radius: 8px;
  }

  .activeIndicator {
    display: flex;
    width: 54px;
    height: 24px;
    padding: 4px 6px;
    overflow: hidden;
    background: var(--color, var(--neutral-5));
    border-radius: 5px;
  }

  .buttonText {
    position: absolute;
    @include sm-sohne;
    padding: 6px;

    &.active {
      color: var(--light-80);
    }
  }

  button {
    @include sm-sohne;
    color: var(--dark-100);
    height: 40px;

    [data-autopilot-system-redesign='on'] & {
      height: 32px;
    }
  }

  &.calloutButton {
    border-radius: 10px;

    [data-autopilot-system-redesign='on'] & {
      border-radius: 8px;
    }

    .buttonText {
      color: var(--dark-80);
    }

    .doubleActionButton {
      border-radius: 0;

      .activeIndicator {
        background: var(--hover-color, var(--neutral-10));

        width: 59px;
        border-radius: 6px;
        height: 28px;
        padding: 4px 6px 5px 6px;

        [data-autopilot-system-redesign='on'] & {
          height: 24px;
        }
      }
    }

    .directActionButton {
      padding: 10px 0 10px 10px;

      [data-autopilot-system-redesign='on'] & {
        padding: 8px 0 8px 6px;
      }

      &:hover {
        background-color: initial;

        .activeIndicator {
          background: linear-gradient(0deg, var(--light-7) 0%, var(--light-7) 100%), var(--color);
        }
      }
    }

    .arrow {
      padding: 10px 6px 10px 0;
      border-radius: 0 100px 100px 0;

      [data-autopilot-system-redesign='on'] & {
        padding: 8px 2px;
        border-radius: 0 8px 8px 0;
      }
    }
  }

  &.quoteButton {
    border-radius: 10px;

    [data-autopilot-system-redesign='on'] & {
      border-radius: 8px;
    }

    .directActionButton {
      &:hover {
        background-color: initial;
      }
    }

    .arrow {
      padding: 10px 6px 10px 0;
      border-radius: 0 100px 100px 0;

      [data-autopilot-system-redesign='on'] & {
        padding: 8px 2px;
        border-radius: 0 8px 8px 0;
      }
    }
  }
}

.arrow {
  @include transition;
  display: flex;
  align-items: center;
  height: 32px;
  padding: 10px 10px 10px 0;
  border-radius: 0 20px 20px 0;

  [data-autopilot-system-redesign='on'] & {
    padding: 8px 8px 8px 0;
    border-radius: 0 8px 8px 0;
  }

  &:hover {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.trigger {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.quoteIndicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 8px 2px 8px 4px;
  border-radius: 6px;
  height: 32px;

  [data-autopilot-system-redesign='on'] & {
    padding: 8px 2px 8px 0;
  }

  &.active {
    background: var(--light-7);

    &:hover {
      background: linear-gradient(0deg, var(--light-7) 0%, var(--light-7) 100%), var(--light-7);
    }
  }

  &:hover {
    background: var(--light-7);
  }
}

.quoteIcon {
  background-color: var(--dark-100);
  display: flex;
  flex-direction: column;
  gap: 1px;
  height: 16px;
  width: 1px;
  margin-top: 1px;
}

.undoDropdownBody {
  width: 152px;
}

.activeHighlightColorsOverride {
  height: 3px;
  border-radius: 2px;
  overflow: hidden;

  & > div {
    border: 1px solid var(--neutral-10);
  }
}
